// eslint-disable-next-line import/prefer-default-export
export const MANDATORY_COLUMNS_MSG_KEY = {
  'User_LABEL.ATTESTATIONS': 'User_LABEL.ATTESTATIONS',
  'Account_LABEL.ATTESTATIONS': 'Account_LABEL.ATTESTATIONS',
  'Role_LABEL.ATTESTATIONS': 'Role_LABEL.ATTESTATIONS',
  'Ent_LABEL.ATTESTATIONS': 'Ent_LABEL.ATTESTATIONS',
};
